import socket from '../../services/socket';

export default {
  namespaced: true,
  state: {
    messages: [],
  },
  getters: {
    getMessages: (state) => state.messages,
  },
  mutations: {
    setMessages: (state, messages) => {
      state.messages = messages;
    },
    addMessage: (state, message) => state.messages.push(message),
    clearMessages: (state) => (state.messages = []),
  },
  actions: {
    applyMessages: ({ commit, rootGetters }, { messages }) => {
      messages.forEach((m) => {
        if (m.author === rootGetters['auth/user'].id) {
          m.author = 'me';
        }
      });

      commit('setMessages', messages);
    },
    sendMessage: ({ commit }, { roomId, message }) => {
      socket.emitSendMessage(roomId, message);

      commit('addMessage', message);
    },
  },
};
